import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postCreateGiveaway = async (payload) => {
  const { data } = await SigliveServiceV1({
    method: 'POST',
    url: '/briefs/giveaways',
    data: payload,
  });

  return data?.data;
};

export default postCreateGiveaway;
